import IResult from '../../models/result/IResult';
import { RevenueConfig } from '../../models/revenue/BillingConfig';
import { sendGet, sendPut } from './generic';
import { getBaseApiUrl } from '../../constants/Urls';

export const getRevenueConfig = (): Promise<IResult<RevenueConfig>> => {
    return sendGet<RevenueConfig>('/RevenueConfig', getBaseApiUrl());
};

export const putRevenueConfig = (config: RevenueConfig): Promise<IResult<RevenueConfig>> => {
    return sendPut<RevenueConfig>('/RevenueConfig', config, getBaseApiUrl());
};
